export default {
    /**
     * @description api请求基础路径
     */
    development: {
        //跳转网站
        indexUrl: "http://zsdy-search-pc.daily.bjzsdy.com/index",
        tuUrl: "http://zsdy-zsg-pc.daily.bjzsdy.com/",
        dyUrl: "http://zsdy-zskdy-pc.daily.bjzsdy.com/",
        downloadUrl: '/webfile/',
        // 登录
        loginLink: 'http://passport.bjzsdy.com/?client_id=zsg&redirectUrl='
    },
    production: {
        //跳转网站
        indexUrl: "https://zsdy-search-pc.shui12366.com/index",
        tuUrl: "http://zsdy-zsg-pc.bjzsdy.com/",
        dyUrl: "https://zsdy-zskdy-pc.shui12366.com/",
        downloadUrl: '/webfile/',
        // 登录
        loginLink: 'http://passport.bjzsdy.com/?client_id=zsg&redirectUrl='
    },
};